import { render, staticRenderFns } from "./UserTypeTemplate.vue?vue&type=template&id=15e4d39d&scoped=true"
import script from "./UserTypeTemplate.vue?vue&type=script&lang=js"
export * from "./UserTypeTemplate.vue?vue&type=script&lang=js"
import style0 from "./UserTypeTemplate.vue?vue&type=style&index=0&id=15e4d39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4d39d",
  null
  
)

export default component.exports